import classNames from 'classnames';
import type { ReactNode, Ref } from 'react';
import CodeEditor, { type CodeEditorProps } from '../../generic/CodeEditor';
import './editor.less';

export interface EditorProps extends Omit<CodeEditorProps, 'name'> {
    children?: ReactNode;
    ref: Ref<HTMLDivElement>;
}

const Editor = ({ className, readOnly, mode, value, onChange, children, ref }: EditorProps) => {
    const containerClasses = classNames('editor-container', className);

    return (
        <div className={containerClasses} ref={ref}>
            {children}
            <CodeEditor
                readOnly={readOnly}
                name="editor"
                mode={mode}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export default Editor;
